export default __webpack_public_path__ + "static/speaker5-66008a882df3f4693d696d1453348d60.jpg";